import { PublicLayout } from '#components/shared/templates/PublicLayout';
import { Seo } from '#src/components/shared/Seo';
import { Page as NextPage } from '#types/next';

import { MarketingHomePage } from './MarketingHomePage';

const Page: NextPage = () => {
  return (
    <>
      <Seo title="Qogita" />

      <MarketingHomePage />
    </>
  );
};

Page.options = {
  public: true,
  getLayout: (page) => <PublicLayout>{page}</PublicLayout>,
};

export { Page };
